const getters = {
	getPoloSelecionado(state) {
		return state.poloSelecionado;
	},
	getPolos(state) {
		return state.polos;
	},
	getPoloPadrao(state) {
		return state.poloPadrao;
	}
};

export default getters;
